import * as React from 'react';

/**
 * Code-split `RecommendationsExplainerDialog`. Render it inside a `React.Suspense` boundary and mount it only once
 * the dialog is requested, so the explainer stays out of learner bundles.
 *
 * Props: `input` (the collection to explain) and `onClose` (called when the dialog is dismissed).
 *
 * @example
 * {isOpen && (
 *   <React.Suspense fallback={null}>
 *     <LazyRecommendationsExplainerDialog input={{ id: collectionId }} onClose={() => setIsOpen(false)} />
 *   </React.Suspense>
 * )}
 */
export const LazyRecommendationsExplainerDialog = React.lazy(
  () => import('bundles/recommendations-explainer/components/RecommendationsExplainerDialog')
);
